import { useMemo } from 'react';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import { ProjectsDto } from '@/core';

export type FormValueType = {
  name: string;
  description?: string;
};

export const useSchemaProject = (projectsListData: ProjectsDto, initialValue: FormValueType) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'projects.createProject' });
  const existingProjects = projectsListData?.items
    .map((project) => project.name?.toLocaleLowerCase())
    .filter((project) => project !== initialValue?.name?.toLocaleLowerCase());

  return useMemo(
    () =>
      Yup.object().shape({
        name: Yup.string()
          .nullable()
          .required()
          .lowercase()
          .notOneOf(existingProjects, t('existing'))
          .max(250),
        description: Yup.string().nullable().max(400),
      }),
    [t, existingProjects],
  );
};
